export default "__VITE_ASSET__d935094d__"